namespace Matrix.Data {
    export interface ModelRow {
        ModelCode?: string;
        Name?: string;
        IsPercent?: boolean;
        Levels?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        LevelName1?: string;
        LevelName2?: string;
        LevelName3?: string;
        LevelName4?: string;
        LevelName5?: string;
        LevelName6?: string;
        LevelName7?: string;
        LevelName8?: string;
        LevelName9?: string;
        LevelName10?: string;
    }

    export namespace ModelRow {
        export const idProperty = 'ModelCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Data.Model';
        export const lookupKey = 'Data.Model';

        export function getLookup(): Q.Lookup<ModelRow> {
            return Q.getLookup<ModelRow>('Data.Model');
        }
        export const deletePermission = 'DataAdmin:Model';
        export const insertPermission = 'DataAdmin:Model';
        export const readPermission = 'Read:Model';
        export const updatePermission = 'DataAdmin:Model';

        export declare const enum Fields {
            ModelCode = "ModelCode",
            Name = "Name",
            IsPercent = "IsPercent",
            Levels = "Levels",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            LevelName1 = "LevelName1",
            LevelName2 = "LevelName2",
            LevelName3 = "LevelName3",
            LevelName4 = "LevelName4",
            LevelName5 = "LevelName5",
            LevelName6 = "LevelName6",
            LevelName7 = "LevelName7",
            LevelName8 = "LevelName8",
            LevelName9 = "LevelName9",
            LevelName10 = "LevelName10"
        }
    }
}
